export var KEY_PREFIX = 'reduxPersist:';
export var REHYDRATE = 'persist/REHYDRATE';


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-persist/es/constants.js
// module id = qujw
// module chunks = 1